import { c as _c } from "react/compiler-runtime";
import { LoginLink } from "@/components/Login/LoginLink/LoginLink.component";
import { Translation } from "@/components/Translation/Translation.component";
export function PaywallLoginNotification() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Translation da="Allerede abonnent?" de="Bereits registriert?" en="Already a subscriber?" no="Allerede abonnent?" sv="Redan prenumerant?" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex justify-center gap-x-1">{t0}<LoginLink position="pw_login" testId="paywall-login-link" variant="primary"><Translation da="Log ind her" de="Hier anmelden" en="Log in here" no="Logg inn her" sv={"Logga in h\xE4r"} /></LoginLink></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}